import { Box, Flex } from 'components/elements'
import { TextField } from 'components/form'
import { UploadFile } from 'components/form/Textfield.styles'
import CheckIcon from '@mui/icons-material/Check'
import { ModalbuttonWrapCss } from 'features/profile/components/EditProfileForm'
import { Button, IconButton } from 'components/button'
import { UseFormRegister } from 'react-hook-form'
import { FlexWrapCSS, wrapStyle } from 'views/Support/SupportForm'
import { IncidentEnum } from 'features/incidents/components/enums'
import { CircleBg, browseButtonCss, uploadCss } from 'features/incidents/components/style'
import { FileIcon } from 'components/icons'
import DeleteIcon from '@mui/icons-material/Delete'
import { useState } from 'react'
type uploadMultiDocumentProps = {
  error: boolean
  errorText: string | undefined
  formField: UseFormRegister<any>
  formName: string
  setFileNameArray: (value: (string | File)[]) => void
  setSelectedFileArray: (value: (string | Blob)[]) => void
  setDocumentCount: (value: number) => void
  documentCount: number
  selectedFileArray: (string | Blob)[]
  fileNameArray: (string | File)[]
  formStyling?: boolean
  setHasDuplicateFiles?: (value: boolean) => void
}

export const UploadMultiDocument = ({
  error,
  errorText,
  formField,
  formName,
  documentCount,
  selectedFileArray,
  fileNameArray,
  setFileNameArray,
  setSelectedFileArray,
  setDocumentCount,
  formStyling,
  setHasDuplicateFiles,
}: uploadMultiDocumentProps) => {
  const [fileExistsError, setFileExistsError] = useState<string[]>([''])

  const fileHandler = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const selectedFilelist = [...selectedFileArray]
    const file_Error = [...fileExistsError]

    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFileArray?.(selectedFilelist)
      return
    }
    const selectedFile = e.target.files[0]
    const isFileNameExist = fileNameArray.includes(selectedFile.name)
    file_Error[index] = isFileNameExist ? 'File already exists' : ''
    setFileExistsError(file_Error)
    if (isFileNameExist) {
      setHasDuplicateFiles?.(true)
      return
    } else {
      setHasDuplicateFiles?.(false)
      selectedFilelist[index] = e.target.files[0]
      setSelectedFileArray(selectedFilelist)

      const fileNamelist = [...fileNameArray]
      fileNamelist[index] = e.target.files[0]?.name
      setFileNameArray(fileNamelist)
    }
  }

  const profileHandler = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const selectedFilelist = [...selectedFileArray]

    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFileArray?.(selectedFilelist)
      return
    }

    selectedFilelist[index] = e.target.files[0]
    setSelectedFileArray(selectedFilelist)
    // TODO: we need it later for croping image
    // if (setSelectedFile) setSelectedFile(e.target.files[0])
    // const objectUrl = URL.createObjectURL(e.target.files[0])
    // if (setPreview) setPreview(objectUrl)
  }
  const handleDelete = (index: number) => {
    const nameFileArray = [...fileNameArray]
    nameFileArray.splice(index, 1)
    setFileNameArray(nameFileArray)
    const newArray = [...selectedFileArray]
    newArray.splice(index, 1)
    setSelectedFileArray(newArray)
    setDocumentCount(documentCount - 1)
    setHasDuplicateFiles?.(false)
  }
  return (
    <>
      <Flex css={FlexWrapCSS}>
        {Array.from(Array(documentCount).keys()).map(index => {
          return (
            <>
              <Box key={index} css={wrapStyle} style={{ width: '100%' }} className={`${!formStyling ? 'noPadding' : ''}`}>
                <UploadFile className={fileNameArray[index] ? 'hideInput' : ''} css={{ pt: '1.5rem', display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                  <TextField
                    accept=".jpg,.jpeg,.png,.docx,.pdf"
                    label={`${IncidentEnum.DOC_UPLOAD_LABEL}`}
                    id={`upload-photo-${index}`}
                    css={{ width: '80%' }}
                    filePlaceholder="No file selected..."
                    type="file"
                    contentClickable
                    contentRight={
                      fileNameArray[index] ? (
                        <CircleBg>
                          <CheckIcon />
                        </CircleBg>
                      ) : (
                        <Box as="label" htmlFor={`upload-photo-${index}`} css={browseButtonCss}>
                          BROWSE
                        </Box>
                      )
                    }
                    contentRightStyling
                    contentRightStyle={uploadCss}
                    contentLeft={
                      fileNameArray[index] ? (
                        <>
                          <FileIcon style={{ flexShrink: 0 }} />
                          <Box
                            key={index}
                            as="p"
                            style={{
                              paddingLeft: 15,
                              margin: 0,
                              overflow: 'hidden',
                              whiteSpace: 'nowrap',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {fileNameArray[index] as string}
                          </Box>
                        </>
                      ) : (
                        ''
                      )
                    }
                    error={error}
                    helperText={errorText}
                    {...formField(`${formName}.${index}`, {
                      onChange: e => {
                        profileHandler(e, index)
                        fileHandler(e, index)
                      },
                      value: fileNameArray[index],
                    })}
                  />

                  {documentCount > 1 && (
                    <Box css={{ alignSelf: 'flex-end', display: 'flex' }}>
                      <IconButton css={IconButtonCss} onClick={() => handleDelete(index)}>
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  )}
                </UploadFile>
              </Box>
              {!!fileExistsError && (
                <Box as="p" className="errorText error">
                  {fileExistsError[index]}
                </Box>
              )}
            </>
          )
        })}
      </Flex>
      <Flex css={ModalbuttonWrapCss} className={`item--left ${!formStyling ? 'noPadding' : ''}`}>
        <Button
          type="button"
          onClick={() => {
            setDocumentCount(documentCount + 1)
          }}
        >
          Add More Documents
        </Button>
      </Flex>
    </>
  )
}
export const IconButtonCss = {
  borderRadius: '50%',
  background: '$primary',
}
